import { useEvent } from './EventProvider';

const useProject = () => useEvent().event.project;

export default useProject;
